var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path10, _g2, _path11, _g3, _path12, _g4, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartner1Mo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 271,
    height: 90,
    viewBox: "0 0 271 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 271,
    height: 90,
    fill: "#E31717"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.4921 22.6074H50.3241C48.5435 22.6074 47.0996 24.0513 47.0996 25.8319V64.1679C47.0996 65.9485 48.5435 67.3924 50.3241 67.3924H88.6601C90.4407 67.3924 91.8846 65.9485 91.8846 64.1679V44.9999H69.4921V22.6074Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6193 28.3555C63.2991 28.5328 62.9641 28.7102 62.2547 30.4836C61.7226 31.7842 59.0033 38.3855 58.0377 40.829H57.3874C56.2248 37.6564 54.5302 33.0453 53.4069 30.1289C52.8552 28.6707 52.5202 28.4737 51.3182 28.3555V27.8037H56.3233V28.3555C54.8651 28.5131 54.7863 28.7496 55.0622 29.4787C55.5548 30.9172 56.9933 34.8385 58.2348 38.1096C59.2792 35.5676 60.5797 32.3557 61.5059 29.8728C61.9394 28.7299 61.7029 28.5525 60.0871 28.3555V27.8037H64.6193V28.3555Z",
    fill: "#E31717"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2827 62.9867V62.435C56.8985 62.2576 57.0561 62.1788 57.0561 60.5038V52.6808C57.0561 50.9861 56.8985 50.9073 55.2827 50.73V50.1782H60.5628V50.73C58.9273 50.9073 58.7696 50.9861 58.7696 52.6808V60.5038C58.7696 62.1985 58.9273 62.2576 60.5628 62.435V62.9867H55.2827Z",
    fill: "#E31717"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9564 59.8241C86.6805 60.77 86.1681 62.1887 85.8726 62.7996C85.3011 62.8981 83.7641 63.2725 82.2665 63.2725C77.5569 63.2725 75.1528 60.0211 75.1528 56.6909C75.1528 52.474 78.2663 49.8926 82.7197 49.8926C84.3355 49.8926 85.6952 50.267 86.3455 50.3458C86.4243 51.2325 86.5623 52.4346 86.7199 53.4198L86.109 53.5578C85.7149 52.2375 85.2026 51.3705 84.1976 50.9567C83.6853 50.7202 82.9759 50.6217 82.2271 50.6217C78.9166 50.6217 77.2022 53.2622 77.2022 56.2771C77.2022 60.0803 79.3895 62.5228 82.3847 62.5228C84.3947 62.5228 85.3602 61.5967 86.3652 59.6261L86.9564 59.8232V59.8241Z",
    fill: "#E31717"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4907 36.0463L73.0858 37.0764H73.5256V37.3684H72.475V37.0764H72.732L74.3792 32.8872H74.7312L76.3775 37.0764H76.6337V37.3684H75.3063V37.0764H75.7085L75.3027 36.0463H73.4916H73.4907ZM73.6054 35.7543H75.1863L74.3954 33.7426L73.6054 35.7543Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1046 35.4237V37.0763H78.5453V37.3683H77.0387V37.0763H77.4794V33.2534H77.0387V32.9614H78.6017C79.0979 32.9614 79.4696 33.0537 79.7168 33.2373C79.9641 33.4209 80.0877 33.6977 80.0877 34.0676C80.0877 34.3677 80.0115 34.6203 79.8584 34.8254C79.7052 35.0305 79.4759 35.1872 79.1705 35.2965L80.3465 37.0754H80.6743V37.3674H79.7616L78.5551 35.4237H78.1055H78.1046ZM78.1046 35.1317H78.2918C78.6707 35.1317 78.9546 35.0448 79.1436 34.8702C79.3317 34.6964 79.4266 34.4357 79.4266 34.0891C79.4266 33.7685 79.3415 33.549 79.1705 33.4308C78.9994 33.3125 78.6814 33.2534 78.2148 33.2534H78.1046V35.1317Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6415 33.2919H81.3732V33.8043H81.0427V32.9614H84.8656V33.8043H84.5351V33.2919H83.2667V37.0763H83.7074V37.3683H82.2009V37.0763H82.6415V33.2919Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0333 37.2215C87.6597 37.3684 87.3176 37.4418 87.0059 37.4418C86.5339 37.4418 86.1496 37.2815 85.854 36.9608C85.5584 36.6402 85.4106 36.2255 85.4106 35.7167C85.4106 35.2079 85.5432 34.8326 85.8092 34.5236C86.0753 34.2146 86.4165 34.0605 86.833 34.0605C87.2182 34.0605 87.5146 34.1904 87.7215 34.4502C87.9294 34.7099 88.0324 35.0825 88.0324 35.5662V35.6764H86.0314C86.0314 36.1018 86.1245 36.435 86.3117 36.676C86.4989 36.9169 86.7578 37.037 87.0901 37.037C87.4224 37.037 87.7242 36.9519 88.0324 36.7808V37.2215H88.0333ZM86.0708 35.3817H87.4107V35.3074C87.4107 34.6705 87.2074 34.3516 86.8008 34.3516C86.5786 34.3516 86.4067 34.4376 86.2857 34.6087C86.1648 34.7798 86.0932 35.0378 86.0717 35.3817H86.0708Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1167_1588",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 30,
    width: 3,
    height: 2
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9783 31.2636C73.9649 31.561 74.1951 31.8127 74.4924 31.8252C74.7898 31.8387 75.0415 31.6085 75.054 31.3111C75.0666 31.0137 74.8364 30.7621 74.539 30.7495C74.531 30.7495 74.5229 30.7495 74.5148 30.7495C74.2282 30.7495 73.99 30.9752 73.9774 31.2645",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1167_1588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.9685 30.7015L73.9185 31.8379L75.0665 31.8884L75.1165 30.752L73.9685 30.7015Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1167_1588",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 77,
    y: 30,
    width: 3,
    height: 2
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M77.991 31.2636C77.9776 31.561 78.2078 31.8127 78.5051 31.8252C78.8025 31.8387 79.0542 31.6085 79.0667 31.3111C79.0793 31.0137 78.8491 30.7621 78.5517 30.7495C78.5437 30.7495 78.5356 30.7495 78.5275 30.7495C78.2409 30.7495 78.0027 30.9752 77.9901 31.2645",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1167_1588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.9813 30.7015L77.9313 31.8379L79.0793 31.8884L79.1294 30.752L77.9813 30.7015Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1167_1588",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 82,
    y: 30,
    width: 2,
    height: 2
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2767 31.2636C82.2633 31.561 82.4944 31.8127 82.7918 31.8252C83.0891 31.8387 83.3408 31.6085 83.3534 31.3111C83.3668 31.0137 83.1366 30.7621 82.8392 30.7495C82.8312 30.7495 82.8231 30.7495 82.8151 30.7495C82.5284 30.7495 82.2902 30.9752 82.2767 31.2645",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1167_1588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.2671 30.7015L82.2171 31.8379L83.3652 31.8884L83.4152 30.752L82.2671 30.7015Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1167_1588",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 78,
    y: 30,
    width: 2,
    height: 2
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6892 30.9894C78.6832 31.1222 78.786 31.2346 78.9188 31.2402C79.0516 31.2458 79.164 31.1434 79.1696 31.0106C79.1756 30.8778 79.0724 30.7654 78.94 30.7598C78.9364 30.7598 78.9328 30.7598 78.9292 30.7598C78.8012 30.7598 78.6948 30.8606 78.6892 30.9898",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1167_1588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.6848 30.7381L78.6624 31.2456L79.1751 31.2682L79.1975 30.7607L78.6848 30.7381Z",
    fill: "white"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M216.646 56.1984C211.642 56.1984 208.591 52.9222 208.591 47.8125C208.591 42.7629 211.703 39.3364 216.433 39.3364C220.491 39.3364 224 41.8312 224 47.5721V48.7743H212.435C212.481 51.5546 214.144 53.1927 216.677 53.1927C218.385 53.1927 219.545 52.4714 220.033 51.5095H223.847C223.145 54.3349 220.491 56.1984 216.646 56.1984ZM212.466 46.1594H220.277C220.247 43.9352 218.751 42.3121 216.494 42.3121C214.144 42.3121 212.588 44.0704 212.466 46.1594Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M206.486 39.5436V42.4892H203.221V50.9653C203.221 52.5283 204.015 52.8589 204.991 52.8589C205.449 52.8589 206.212 52.8289 206.7 52.7988V55.9247C206.242 56.0149 205.479 56.075 204.503 56.075C201.574 56.075 199.316 54.6623 199.346 51.5965V42.4892H196.966V39.5436H199.346V35.6362H203.221V39.5436H206.486Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M185.524 55.8671V39.5461H189.307V42.2513H189.491C190.07 40.3877 191.687 39.3057 193.579 39.3057C194.006 39.3057 194.617 39.3357 194.983 39.3958V42.9426C194.647 42.8223 193.823 42.7021 193.183 42.7021C191.016 42.7021 189.43 44.1749 189.43 46.2488V55.8671H185.524Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M166.851 55.8668H162.61L170.391 34.1055H175.273L183.084 55.8668H178.842L177.012 50.4866H168.682L166.851 55.8668ZM169.75 47.3306H175.944L172.923 38.5539H172.74L169.75 47.3306Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M158.796 48.6837C157.484 48.6837 156.416 47.6317 156.416 46.3393C156.416 45.0769 157.484 44.0249 158.796 44.0249C160.047 44.0249 161.145 45.0769 161.145 46.3393C161.145 47.6317 160.047 48.6837 158.796 48.6837Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M149.154 41.4382C148.697 38.8232 146.561 37.3204 143.876 37.3204C140.245 37.3204 137.712 40.0556 137.712 44.9849C137.712 49.9744 140.275 52.6495 143.876 52.6495C146.5 52.6495 148.636 51.2067 149.154 48.6519H153.152C152.541 52.8298 149.063 56.1661 143.815 56.1661C137.987 56.1661 133.715 51.9882 133.715 44.9849C133.715 37.9516 138.048 33.8037 143.815 33.8037C148.697 33.8037 152.48 36.599 153.152 41.4382H149.154Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M130.145 34.1055V55.8668H126.179V34.1055H130.145Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M107.444 34.1055L113.18 51.268H113.424L119.191 34.1055H123.554L115.743 55.8668H110.861L103.081 34.1055H107.444Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 67.2529,
    y: 22.6074,
    width: 4.4785,
    height: 44.785,
    fill: "#E31717"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 91.8846,
    y: 42.7607,
    width: 4.4785,
    height: 44.785,
    transform: "rotate(90 91.8846 42.7607)",
    fill: "#E31717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner1Mo);
export default __webpack_public_path__ + "static/media/partner1Mo.02719c342757b9dbfc3ecc67c439f3ee.svg";
export { ForwardRef as ReactComponent };